import {
  ActionStatus,
  IGetRecentWebhooksResponse,
  IResendWebhookResponse,
  IRetryFailedWebhooksResponse,
  WebhookEventKey,
} from 'shared';

import { orgHeader } from '../../../../common/lib/axiosBaseQuery';
import { emptySplitApi } from '../baseApi';
import { CacheTags } from '../../types/cacheTags';

export const webhooksApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    fetchRecentWebhooks: builder.query<IGetRecentWebhooksResponse, string>({
      query: organisationId => ({
        url: `webhooks`,
        method: `GET`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      providesTags: [
        { type: CacheTags.Webhooks, id: `LIST` },
      ],
    }),
    resendWebhook: builder.mutation<IResendWebhookResponse, { organisationId: string; webhookId: number }>({
      query: ({ organisationId, webhookId }) => ({
        url: `webhooks/${webhookId}/resend`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      // A successful resend can also clear the webhook error state on settings
      invalidatesTags: [
        { type: CacheTags.Webhooks, id: `LIST` },
        { type: CacheTags.Settings, id: `LIST` },
      ],
    }),
    retryFailedWebhooks: builder.mutation<IRetryFailedWebhooksResponse, string>({
      query: organisationId => ({
        url: `webhooks/retry-failed`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
      }),
      invalidatesTags: [
        { type: CacheTags.Webhooks, id: `LIST` },
        { type: CacheTags.Settings, id: `LIST` },
      ],
    }),
    sendTestWebhook: builder.mutation<IResendWebhookResponse, { organisationId: string; event: WebhookEventKey; status: ActionStatus.COMPLETE | ActionStatus.FAILED }>({
      query: ({ organisationId, event, status }) => ({
        url: `webhooks/test`,
        method: `POST`,
        headers: {
          [orgHeader]: organisationId,
        },
        data: { event, status },
      }),
    }),
  }),
});

export const {
  useFetchRecentWebhooksQuery,
  useResendWebhookMutation,
  useRetryFailedWebhooksMutation,
  useSendTestWebhookMutation,
} = webhooksApi;
